import * as API from '@api'
import * as THEME_API from '@api/theme'
import { getDevComponents } from '@api/dev'
import * as T from './types'

const actions = {
    [T.FETCH_APP_DETAIL]({ commit }, payload) {
        return API.getAppDetail(payload).then(res => {
            commit(T.SET_APP_DETAIL, res)
            return res
        })
    },
    [T.GET_COMPONENTS](store, payload) {
        return API.getComponents(payload)
    },
    [T.FETCH_CONF_LIST]() {
        return API.getConfList()
    },

    [T.FETCH_PAGES]({ state }, payload = {}) {
        const { app } = state
        return API.getPages({
            ...payload,
            appId: app?.appId,
        })
    },

    [T.GET_APP_SETTING]({ commit }, payload) {
        return THEME_API.getSelectedTheme(payload).then(res => {
            // appSetting兼容
            const { global } = res.content || {}
            const appSetting = {
                body: {
                    header: {
                        hide: !(global.page.h5ShowHeader) || false,
                    },
                },
                style: {
                    primaryColor: global.color.primary,
                    secondaryColor: global.color.secondary,
                    globalBgColor: global.page.pageBgColor,
                },
            }
            commit(T.SET_APP_SETTING, { ...res.content, ...appSetting })
            return res.content
        })
    },

    [T.GET_BUILD_FUNCTION_STATUS](store, payload) {
        return API.getFunctionBuildStatus(payload)
    },

    [T.GET_VALIDATE_FUNCTION_STATUS](store, payload) {
        return API.getValidateFunctionBuildStatus(payload)
    },
    // 开发本地自定义组件
    [T.GET_LOCAL_COMPONENT]({ commit, state }) {
        if (!state.devComponentHost || !state.devComponentPort) {
            // eslint-disable-next-line no-console
            console.log('[paas] 未添加本地组件调试配置，不启动调试')
            return Promise.resolve([])
        }

        return getDevComponents({
            devComponentHost: state.devComponentHost,
            devComponentPort: state.devComponentPort,
        }).then(res => {
            commit(T.SET_LOCAL_COMPONENT, res.data)
            return res.data
        }).catch(() => {
            // eslint-disable-next-line no-console
            console.log('[paas] 未启动本地开发服务，不启动调试')
            return []
        })
    },
    [T.GET_ASSIGNED_PAGE](store, payload) {
        return API.getAssignedPage(payload)
    },
}

export default actions
